import { useEffect, useState } from 'react';
import api from '../lib/api';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { SocialMediaEditor } from './SocialMediaEditor';
import { Building2, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const FIELDS = [
  { k: 'name', l: 'Organization Name', span: 2 },
  { k: 'tagline', l: 'Tagline', span: 2 },
  { k: 'email', l: 'Contact Email' },
  { k: 'phone', l: 'Phone' },
  { k: 'website', l: 'Website', span: 2 },
  { k: 'address_line1', l: 'Office Address', span: 2 },
  { k: 'address_city', l: 'Office City' },
  { k: 'address_state', l: 'Office State' },
  { k: 'address_zip', l: 'Office Zip' },
  { k: 'mailing_address_line1', l: 'Mailing Address / P.O. Box', span: 2 },
  { k: 'mailing_city', l: 'Mailing City' },
  { k: 'mailing_state', l: 'Mailing State' },
  { k: 'mailing_zip', l: 'Mailing Zip' },
];

export default function OrgProfileCard() {
  const [profile, setProfile] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get('/org-profile').then((r) => setProfile({ social_media: [], ...r.data }));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const payload = { ...profile };
      delete payload.id; delete payload.updated_at; delete payload.updated_by;
      await api.put('/org-profile', payload);
      toast.success('Organization profile saved');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Save failed');
    } finally {
      setSaving(false);
    }
  };

  if (!profile) return null;

  return (
    <Card data-testid="org-profile-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2"><Building2 className="w-5 h-5 text-magenta" /> Organization Profile</CardTitle>
        <p className="text-xs text-slate-500 mt-1">AAWTA's public profile — used for future website integrations, marketing automation, newsletters, and public pages.</p>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-2 gap-3">
          {FIELDS.map((f) => (
            <div key={f.k} className={f.span === 2 ? 'col-span-2' : ''}>
              <Label className="text-xs">{f.l}</Label>
              <Input value={profile[f.k] || ''} onChange={(e) => setProfile({ ...profile, [f.k]: e.target.value })} data-testid={`org-${f.k}`} />
            </div>
          ))}
        </div>
        <SocialMediaEditor value={profile.social_media || []} onChange={(v) => setProfile({ ...profile, social_media: v })} />
        <Button onClick={save} disabled={saving} className="bg-magenta hover:bg-magenta/90" data-testid="org-profile-save">
          {saving && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} Save Organization Profile
        </Button>
      </CardContent>
    </Card>
  );
}
